import {
  UNLEASH_EXPERIMENTS,
  CheckoutExperimentVariant,
  isCheckoutVariant,
} from '@utils/constants'
import { useFlagsStatus } from '@unleash/proxy-client-react'
import useVariant from '@services/unleash/useVariant'
import { AMBASSADOR_SALE_TYPE } from '@utils/enum'
import { useEffect } from 'react'

/**
 * Reads the checkout AB experiment variant from Unleash and persists it to sessionStorage
 * for consumers that use `useCheckoutFlowVariant`.
 *
 * Must stay mounted across route changes (e.g. App); landing redirects before flags are ready.
 */
const useCheckoutExperimentFlag = () => {
  const { flagsReady } = useFlagsStatus()
  const unleashVariant = useVariant(UNLEASH_EXPERIMENTS.PW_CAPTCHA)

  const flagEnabled = Boolean(unleashVariant?.enabled)
  const unleashVariantValue = unleashVariant?.payload?.value
  const variantVal: CheckoutExperimentVariant = isCheckoutVariant(unleashVariantValue)
    ? unleashVariantValue
    : CheckoutExperimentVariant.CONTROL

  useEffect(() => {
    if (typeof window === 'undefined' || !window.sessionStorage) return
    if (!flagsReady || !flagEnabled) return
    sessionStorage.setItem(AMBASSADOR_SALE_TYPE.CHECKOUT_FLOW_VARIANT, variantVal)
  }, [flagsReady, flagEnabled, variantVal])

  return {
    flagEnabled,
    flagsReady,
    unleashVariantValue: variantVal,
    variant: unleashVariant,
  }
}

export default useCheckoutExperimentFlag
